<div class="deal-detail-page">
  @if (loading) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }
  <h3>
    {{
      'dashboard-commission-details.component.commission_header'
        | localise: 'Commission'
    }}
  </h3>
  <ul>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.property_address'
            | localise: 'Property Address'
        }}
      </h4>
      <p>{{ externalDeal | fullAddress }}</p>
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.commission_amount'
            | localise: 'Your Net Commission'
        }}
      </h4>
      <p>
        {{
          externalDeal?.agentCommissionAmount | currencyJs: { showSymbol: true }
        }}
      </p>
    </li>
    <li>
      <h4>
        {{
          'deal-details.component.expected_closing_date'
            | localise: 'Expected Closing Date'
        }}
      </h4>
      <p>{{ externalDeal?.closingDate | dateApp: formatDateEnum.MMMDD }}</p>
    </li>
    <li>
      <h4>
        {{ 'deal-details.component.selling_agent' | localise: 'Selling Agent' }}
      </h4>
      <p>{{ user.fullName }}</p>
    </li>
    @if (
      externalDeal?.payrollToClocDealLink?.userDealDocuments?.[0];
      as document
    ) {
      <li>
        <h4>
          {{
            'advance-application-completed.component.contract_of_sale_header'
              | localise: 'Contract of Sale'
          }}
        </h4>
        <ng-container>
          @if (loadingFile) {
            <mat-spinner [diameter]="22"></mat-spinner>
          }
          @if (!loadingFile) {
            <p>
              <app-preview-document
                [documentName]="document.s3Key | fileName"
                [fileName]="document.s3Key"
                [documentId]="document.id">
                <a href="javascript:void(0)" class="tongo-link">
                  {{
                    'deal-details.component.view_contract_link'
                      | localise: 'View Contract'
                  }}
                </a>
              </app-preview-document>
            </p>
          }
        </ng-container>
      </li>
    }
  </ul>

  <!-- Advance section -->
  @if (externalDeal?.payrollToClocDealLink?.approvedLimitAmount) {
    <div>
      <mat-divider></mat-divider>
      <h3>
        {{
          'dashboard-commission-details.component.cloc' | localise: 'Advance'
        }}
      </h3>
      <ul>
        <li>
          <h4>
            {{
              'deal-details.component.date_requested'
                | localise: 'Date Requested'
            }}
          </h4>
          <p>
            {{ externalDeal?.createdAt | dateApp: formatDateEnum.MMMDDYYYY }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.approved_limit'
                | localise: 'Approved Limit'
            }}
          </h4>
          <p>
            {{
              externalDeal.payrollToClocDealLink?.approvedLimitAmount
                | currencyJs: { showSymbol: true }
            }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.amount_used'
                | localise: 'Amount Used'
            }}
          </h4>
          <p>
            {{ externalDeal.clocAmountUsed | currencyJs: { showSymbol: true } }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.amount_remaining'
                | localise: 'Amount Remaining'
            }}
          </h4>
          <p>
            {{
              externalDeal.clocAmountRemaining
                | currencyJs: { showSymbol: true }
            }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.total_fees'
                | localise: 'Total Fees'
            }}
          </h4>
          <p>
            {{ externalDeal.clocTotalFees | currencyJs: { showSymbol: true } }}
          </p>
        </li>
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.balance_owed'
                | localise: 'Balance Owed'
            }}
          </h4>
          <p>
            {{
              externalDeal.clocBalanceOwed | currencyJs: { showSymbol: true }
            }}
          </p>
        </li>
        <!-- TODO Next Payment Due-->
        <li>
          <h4>
            {{
              'dashboard-commission-details.component.next_payment_due'
                | localise: 'Next Payment Due'
            }}
          </h4>
          <p>
            {{ externalDeal?.createdAt | dateApp: formatDateEnum.MMMDDYYYY }}
          </p>
        </li>
      </ul>
      <div class="alert">
        {{
          'deal-details.component.please_contact_support'
            | localise
              : 'If you need additional support regarding this deal, please contact support by emailing'
        }}
        <a href="mailto:support@gettongo.com">{{
          'deal-details.component.support_gettongo_com_link'
            | localise: 'support@gettongo.com'
        }}</a>
        {{
          'deal-details.component.support_calling'
            | localise: 'or calling (929) 456-5396'
        }}.
      </div>
    </div>
  }
  <mat-divider></mat-divider>
  <!-- Deposit section -->
  <h3>
    {{
      'dashboard-commission-details.component.deposit_header'
        | localise: 'Deposit'
    }}
  </h3>
  <ul>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.upload_date'
            | localise: 'Upload Date'
        }}
      </h4>
      <p>{{ externalDeal?.createdAt | dateApp: formatDateEnum.MMMDD }}</p>
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.total_amount'
            | localise: 'Total Amount'
        }}
      </h4>
      <p>
        {{
          externalDeal?.depositTotalAmount
            | currencyJs: { showSymbol: true, negativeToZero: true }
        }}
      </p>
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.source' | localise: 'Source'
        }}
      </h4>
      <p>
        {{
          externalDeal?.isFromCda
            ? externalDeal?.cdaTitleName
            : externalDeal?.brokerApi?.name
        }}
      </p>
    </li>
    @if (externalDeal) {
      <li>
        <h4>
          {{
            'dashboard-commission-details.component.funding_source'
              | localise: 'Funding Source'
          }}
        </h4>
        <p>
          {{ externalDeal.isFromCda ? 'Title' : 'Brokerage' }}
        </p>
      </li>
    }
    <li>
      <h4>
        {{ 'dashboard-deals.component.status_header' | localise: 'Status' }}
      </h4>
      <app-deal-status-with-color
        [dealTransactionStatus]="
          externalDeal?.transactionStatus
        "></app-deal-status-with-color>
    </li>
  </ul>
  @if (
    externalDeal?.transactionStatus ===
    dealTransactionStatusEnum.NeedsConfirmation
  ) {
    <div class="alert-wrapper">
      <p class="alert">
        {{
          'dashboard-commission-details.component.deposit_need_confirmation'
            | localise
              : 'You have a deposit waiting for your approval. You need to confirm your distribution settings before the funds can be sent to your accounts.'
        }}
      </p>
    </div>
    <button
      mat-button
      (click)="confirmDepositDistributions(dealId)"
      class="action-button action-button--primary"
      type="button">
      {{
        'dashboard-commission-details.component.deposit_confirmation_button'
          | localise: 'Confirm Distributions'
      }}
    </button>
  }

  <mat-divider></mat-divider>
  <!-- Deposit Breakdown section -->
  @if (
    externalDeal?.transactionStatus === dealTransactionStatusEnum.Initiated ||
    externalDeal?.transactionStatus === dealTransactionStatusEnum.Delivered ||
    externalDeal?.transactionStatus === dealTransactionStatusEnum.Refunded ||
    externalDeal?.transactionStatus === dealTransactionStatusEnum.Failed
  ) {
    @if (
      externalDeal?.transactionStatus === dealTransactionStatusEnum.Initiated ||
      externalDeal?.transactionStatus === dealTransactionStatusEnum.Delivered
    ) {
      <div class="dialog-header commission">
        {{
          'confirm-deposit-distributions.net_commission'
            | localise: 'Net Commission'
        }}
        <div class="m-l-auto">
          {{
            externalDeal?.agentCommissionAmount
              | currencyJs: { showSymbol: true }
          }}
        </div>
      </div>
      <div class="dialog-header commission">
        {{
          'dashboard-commission-details.component.deposit_repayment'
            | localise: 'Advance Repayment'
        }}
        <div class="m-l-auto">
          <p>
            {{
              externalDeal.depositRepayment | currencyJs: { showSymbol: true }
            }}
          </p>
        </div>
      </div>
      <div class="dialog-header total">
        {{
          'dashboard-commission-details.component.total_deposit'
            | localise: 'Total to Deposit'
        }}
        <div class="m-l-auto">
          @if (externalDeal.depositBreakdown.value > 0) {
            <p>
              {{
                externalDeal.depositBreakdown | currencyJs: { showSymbol: true }
              }}
            </p>
          }
        </div>
      </div>
    }
    @if (agentCommissionTransactions.length > 0) {
      <table
        mat-table
        (matSortChange)="setSort($event.active, $event.direction)"
        [dataSource]="agentCommissionTransactions"
        matSort>
        <ng-container matColumnDef="accountNickname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'commission-details.component.deposit_breakdown_account_nickname'
                | localise: 'Account Nickname'
            }}
          </th>
          <td mat-cell *matCellDef="let app">
            {{
              app?.bankAccount
                ? app?.bankAccount?.accountNickname
                : app?.cardNickname
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'commission-details.component.deposit_breakdown_date_delivered'
                | localise: 'Date Send'
            }}
          </th>
          <td mat-cell *matCellDef="let app">
            @if (app.status === TransactionStatusEnum.Failed) {
            } @else {
              {{ app?.effectiveDate | dateApp: formatDateEnum.MMMDD }}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'commission-details.component.deposit_breakdown_account'
                | localise: 'Account'
            }}
          </th>
          <td mat-cell *matCellDef="let app">
            @if (app.type === TransactionTypeEnum.PaymentFromPartner) {
              <div>
                {{
                  'dashboard-commission-details.component.repayment_debts_tongo'
                    | localise: 'Repayment of debts to Tongo'
                }}
              </div>
            } @else {
              {{ app | bankInfo }}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="distributionAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'dashboard-deals.component.deposit_breakdown_distribution_amount_percent'
                | localise: 'Distribution Amount'
            }}
          </th>
          <td mat-cell *matCellDef="let app">
            {{ app.depositPercent | currencyJs: { showSymbol: false } }}%
          </td>
        </ng-container>
        <ng-container matColumnDef="depositAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'dashboard-deals.component.deposit_breakdown_amount'
                | localise: 'Deposit Amount'
            }}
          </th>
          <td mat-cell *matCellDef="let app">
            {{ app?.amount | currencyJs: { showSymbol: true } }}
          </td>
        </ng-container>
        <ng-container matColumnDef="depositStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'dashboard-deals.component.deposit_status'
                | localise: 'Deposit Status'
            }}
          </th>
          <td mat-cell *matCellDef="let app">
            <app-deal-status-with-color
              [dealTransactionStatus]="
                app.status | convertToDealTransactionStatus
              "></app-deal-status-with-color>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsPayroll"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsPayroll"></tr>
      </table>
    }
  }

  <!--  <div class="bottom-buttons">-->
  <!--    <a-->
  <!--      [href]="-->
  <!--        '/api/external-deal/' +-->
  <!--          dealId +-->
  <!--          '/statement?download=' +-->
  <!--          downloadEnum.Attachment | safe-->
  <!--      "-->
  <!--      class="upload-button p-button p-button&#45;&#45;rounded p-button&#45;&#45;apply-now-header">-->
  <!--      {{-->
  <!--        'dashboard-commission-details.component.download_statement'-->
  <!--          | localise : 'Download Statement'-->
  <!--      }}-->
  <!--    </a>-->
  <!--  </div>-->

  <!--<ng-container
    *ngIf="!!transactionList?.total && (deal | isStatement)"
[ngTemplateOutlet]="transactionTable"></ng-container>-->
</div>
